// extracted by mini-css-extract-plugin
export default {"currency":"PffyE","info":"fXdb0","row":"TCYYJ","info__title":"Gn6f2"};